import '../scss/main.scss'

function attachModalListeners(modalElm) {
    modalElm.querySelector('.cof-modal__content__close').addEventListener('click', () => toggleModal( `#${modalElm.getAttribute('id')}`));
}

function detachModalListeners(modalElm) {
    modalElm.querySelector('.cof-modal__content__close').removeEventListener('click', () => toggleModal( `#${modalElm.getAttribute('id')}`));

}

function toggleModal(modalSelector = '#cof-modal') {
    console.log(modalSelector);
    var modal = document.querySelector(modalSelector);
  var currentState = modal.style.display;

  // If modal is visible, hide it. Else, display it.
  if (currentState === 'none') {
    modal.style.display = 'block';
    attachModalListeners(modal);
  } else {
    modal.style.display = 'none';
    detachModalListeners(modal);
  }
}

window.toggleModal = toggleModal;

// The debounce function receives our function as a parameter
const debounce = (fn) => {

  // This holds the requestAnimationFrame reference, so we can cancel it if we wish
  let frame;

  // The debounce function returns a new function that can receive a variable number of arguments
  return (...params) => {

    // If the frame variable has been defined, clear it now, and queue for next frame
    if (frame) {
      cancelAnimationFrame(frame);
    }

    // Queue our function call for the next frame
    frame = requestAnimationFrame(() => {

      // Call our function and pass any params we received
      fn(...params);
    });

  }
};

  // Reads out the scroll position and stores it in the data attribute
  // so we can use it in our stylesheets
  const storeScroll = () => {
    if(window.scrollY >= 0){
      document.documentElement.dataset.scroll = window.scrollY;
    }
  }

  // Listen for new scroll events, here we debounce our `storeScroll` function
  document.addEventListener('scroll', debounce(storeScroll), { passive: true });

  // Update scroll position for first time
  storeScroll();

var scrollComponent = document.querySelectorAll('.cof-scroll-up');
if (scrollComponent) {
	scrollComponent.forEach(function (el) {
		el.addEventListener('click', () => {
			scrollToTop(1000);
		});
	});
}

function scrollToTop(scrollDuration) {
	var scrollStep = -window.scrollY / (scrollDuration / 15),
		scrollInterval = setInterval(function () {
			if (window.scrollY != 0) {
				window.scrollBy(0, scrollStep);
			}
			else clearInterval(scrollInterval);
		}, 15);
}

document.addEventListener('DOMContentLoaded', () => {
  const header = document.querySelector('.cof-header');
  const navToggle = document.getElementById('cof-nav-toggle');
  const navMain = document.getElementById('cof-nav-main');
  
  // Actualizamos el selector BEM
  const submenuToggles = document.querySelectorAll('.cof-nav__link--toggle');

  const focusableElements = header.querySelectorAll(
    'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])'
  );
  const firstFocusableElement = focusableElements[0];
  const lastFocusableElement = focusableElements[focusableElements.length - 1];

  const toggleMenu = () => {
    const isExpanded = navToggle.getAttribute('aria-expanded') === 'true';
    
    if (isExpanded) {
      navToggle.setAttribute('aria-expanded', 'false');
      navMain.classList.remove('is-open');
      document.body.classList.remove('no-scroll');
      navToggle.focus();
    } else {
      navToggle.setAttribute('aria-expanded', 'true');
      navMain.classList.add('is-open');
      document.body.classList.add('no-scroll');
    }
  };

  if (navToggle && navMain) {
    navToggle.addEventListener('click', toggleMenu);
  }

  header.addEventListener('keydown', (e) => {
    const isExpanded = navToggle.getAttribute('aria-expanded') === 'true';
    const isMobile = window.getComputedStyle(navToggle).display !== 'none';
    
    if (!isExpanded || !isMobile) return;

    const isTabPressed = e.key === 'Tab' || e.keyCode === 9;
    const isEscPressed = e.key === 'Escape' || e.keyCode === 27;

    if (isEscPressed) {
      e.preventDefault();
      toggleMenu();
    }

    if (isTabPressed) {
      if (e.shiftKey) {
        if (document.activeElement === firstFocusableElement) {
          lastFocusableElement.focus();
          e.preventDefault();
        }
      } else {
        if (document.activeElement === lastFocusableElement) {
          firstFocusableElement.focus();
          e.preventDefault();
        }
      }
    }
  });

  submenuToggles.forEach(toggle => {
    toggle.addEventListener('click', (e) => {
      e.preventDefault();
      // Actualizamos el selector BEM
      const parentLi = toggle.closest('.cof-nav__item--has-submenu');
      const isExpanded = toggle.getAttribute('aria-expanded') === 'true';

      submenuToggles.forEach(otherToggle => {
        if (otherToggle !== toggle) {
          otherToggle.setAttribute('aria-expanded', 'false');
          otherToggle.closest('.cof-nav__item--has-submenu').classList.remove('is-open');
        }
      });

      if (isExpanded) {
        toggle.setAttribute('aria-expanded', 'false');
        parentLi.classList.remove('is-open');
      } else {
        toggle.setAttribute('aria-expanded', 'true');
        parentLi.classList.add('is-open');
      }
    });

    // Actualizamos el selector BEM
    const parentLi = toggle.closest('.cof-nav__item--has-submenu');
    parentLi.addEventListener('keydown', (e) => {
      const isEscPressed = e.key === 'Escape' || e.keyCode === 27;
      
      if (isEscPressed && toggle.getAttribute('aria-expanded') === 'true') {
        e.preventDefault();
        e.stopPropagation(); 
        
        toggle.setAttribute('aria-expanded', 'false');
        parentLi.classList.remove('is-open');
        toggle.focus(); 
      }
    });
  });

  document.addEventListener('click', (e) => {
    // Actualizamos los selectores BEM
    if (!e.target.closest('.cof-nav')) {
      submenuToggles.forEach(toggle => {
        toggle.setAttribute('aria-expanded', 'false');
        toggle.closest('.cof-nav__item--has-submenu').classList.remove('is-open');
      });
    }
  });
});
